import axios from 'axios'

const baseURL = process.env.VUE_APP_ORIGINACION_URL

const api_token = process.env.VUE_APP_ORIGINACION_TOKEN

const http = axios.create({ baseURL })

// Add api_token to body for each request
http.interceptors.request.use(config => Object.assign(config, { data: { api_token, ...config.data } }))

http.interceptors.response.use(({data}) => data)

export default http